import axiosBaseApi from '../common/lib/axiosBaseApi';
import {
  AgentRakeQuery,
  AgentRakeShare,
  AgentRakeStats,
  ReferralStats,
  TotalUserRakeBackPayout,
  UserRakePayout,
  UserRakeStats,
} from './rake.types';

export const getRakeStats = async () => await axiosBaseApi.get<UserRakeStats>(`/v1/rake/stats`);
export const getRakeAgentStats = async () => await axiosBaseApi.get<AgentRakeStats>(`/v1/rake/agent-stats`);

export const getRakePayouts = async () => await axiosBaseApi.get<UserRakePayout[]>(`/v1/rake/rake-share`);
export const getReferralDataById = async (referralId: string) =>
  await axiosBaseApi.get<ReferralStats>(`/v1/rake/referral-stats/${referralId}`);
export const getAgentRakeShare = ({ filter, sort, paginationOptions }: AgentRakeQuery) => {
  return axiosBaseApi.get<{ data: AgentRakeShare[]; total: number }>(`/v1/rake/agent-rake-share/`, {
    params: {
      filter,
      sort,
      paginationOptions,
    },
  });
};
export const getTotalUnpaidRakeback = async () =>
  await axiosBaseApi.get<TotalUserRakeBackPayout>(`/v1/rake/unpaid-rake-back-total`);
